import {eventManager} from '@/integrations/SSE/helpers'
import {SSEEventType} from '@/integrations/SSE/types'
// import {Message} from '../../../features/chat/chat.model'
import {useEffect} from 'react'
import {UserV3} from '@/features/authentication/types'

export const useSSE = ({
    eventSource,
    eventType,
    user,
    disabled = false
}: {
    eventSource: EventSource | null
    eventType: SSEEventType
    user: UserV3
    disabled?: boolean
}) => {
    const eventHandler = (event: MessageEvent) => {
        eventManager[eventType]({...JSON.parse(event.data), user})
    }
    useEffect(() => {
        if (eventSource && !disabled) {
            eventSource.addEventListener(eventType, eventHandler)
            // Cleanup function to remove the event listener
            return () => {
                eventSource.removeEventListener(eventType, eventHandler)
            }
        }
    }, [eventSource])
}

export default useSSE
